import {
  FormControl,
  InputLabel,
  Select,
  Stack,
  TextField,
} from '@mui/material'
import { useUserContext } from '../../../Contexts/UserConfig'
import { tsGetSample } from '../../../Typescript/API_Response'
import { listFromCodes } from '../../../Functions/ListItemGenerator'
import {
  useUpdateSampleResultComment,
  useUpdateSampleResultsBulk,
} from '../../../APIs/Hooks/SampleHooks'
import { stackGap } from '../../../Constants&Theme/Spacing'

function SampleResult({ sample }: { sample: tsGetSample | undefined }) {
  const { loginConfig, loadingConfig } = useUserContext()
  const { mutate: updateResults } = useUpdateSampleResultsBulk(
    sample?.SampleID ? [sample?.SampleID] : [],
  )
  const { mutate: updateResultComment } = useUpdateSampleResultComment(
    sample?.SampleID,
  )
  const resultOptions = listFromCodes(loginConfig, 'ResultID', loadingConfig)

  return (
    <Stack
      direction={'row'}
      width={1}
      gap={stackGap.row}
    >
      <FormControl
        sx={{ flex: 1 }}
        fullWidth
      >
        <InputLabel>Result</InputLabel>
        <Select
          label="Result"
          name="result"
          disabled={!loginConfig?.Modules?.EditScreenRequest}
          value={sample?.Result ?? ''}
          onChange={(e) => updateResults(e.target.value)}
        >
          {resultOptions}
        </Select>
      </FormControl>
      <TextField
        label="Result Comments"
        defaultValue={sample?.ResultComments ?? ''}
        disabled={!loginConfig?.Modules?.EditScreenRequest}
        onBlur={(e) => {
          if (sample?.ResultComments !== e.target.value) {
            updateResultComment(e.target.value)
          }
        }}
        sx={{ flex: 2 }}
      />
    </Stack>
  )
}

export default SampleResult
